(function () {
  // nur einmal global
  if (window.__quickSizeAddBound) return;
  window.__quickSizeAddBound = true;

  function getTarget(t) {
    return (t && t.nodeType === 3) ? t.parentElement : t; // Textnode -> Element
  }

  document.addEventListener('click', async function (e) {
    const target = getTarget(e.target);
    const sizeEl = target && target.closest ? target.closest('.pc-size-text') : null;
    if (!sizeEl) return;

    // verhindert, dass der Produkt-Link / andere Handler den Klick klauen
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if (sizeEl.getAttribute('aria-disabled') === 'true') return;

    const variantId = sizeEl.getAttribute('data-variant-id');
    if (!variantId) {
      console.warn('[quick-size-add] Missing data-variant-id on', sizeEl);
      return;
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({ id: Number(variantId), quantity: 1 })
      });

      if (!res.ok) {
        let err = {};
        try { err = await res.json(); } catch (_) {}
        console.error('[quick-size-add] Add failed', res.status, err);
        return;
      }

      // Prestige: cart refresh
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      // Drawer öffnen (Prestige Trigger finden)
      const cartTrigger =
        document.querySelector('[aria-controls="cart-drawer"]') ||
        document.querySelector('[data-drawer-id="cart-drawer"]') ||
        document.querySelector('a[href="/cart"]');

      if (cartTrigger) cartTrigger.click();
      else window.location.href = '/cart';

    } catch (err) {
      console.error('[quick-size-add] Network/JS error', err);
    }
  }, true); // capture=true => wir sind vor Prestige dran
})();
